import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import type { AddressType } from '@sweetgreen/garnish';

import { useNavigateToMainTabs } from '../../../../navigation';
import type { AppStackParamList } from '../../../../navigation/AppNavigation.props';

export const useHomeNavigation = () => {
  const navigation =
    useNavigation<NativeStackNavigationProp<AppStackParamList>>();
  const navigateToMainTabs = useNavigateToMainTabs();

  const handleGoHome = useCallback(() => {
    void navigateToMainTabs('HomeTab', { screen: 'Home' });
  }, [navigateToMainTabs]);

  const handleGoToLocations = useCallback(
    (locationSelectionType: AddressType) => {
      navigation.navigate('MainTabs', {
        screen: 'MenuTab',
        params: {
          screen: 'Locations',
          params: { locationSelectionType },
        },
      });
    },
    [navigation],
  );

  const handleGoToDefaultLocations = useCallback(() => {
    navigation.navigate('MainTabs', {
      screen: 'MenuTab',
      params: {
        screen: 'Locations',
        params: {
          locationSelectionType: 'pickup',
        },
      },
    });
  }, [navigation]);

  return {
    handleGoHome,
    handleGoToLocations,
    handleGoToDefaultLocations,
  };
};
